<div class="dropdown emoji-btn is-right is-up" [ngClass]="{'is-active': emojimartToggle}" (click)="toggleEmojiMart()">
  <span><i class="fa fa-smile-o has-text-info mar-t-5" aria-hidden="true"></i></span>
  <div class="dropdown-menu">
    <div class="dropdown-content">
      <div class="dropdown-item">
        <span class="icon-emoji">

          <!-- <span [innerHTML]="':'+emoji+':' | emojis"></span> -->

          <emoji-mart
          [set]="set"
          [isNative]="native"
          [hideRecent]="true"
          (emojiSelect)="appendEmojiText($event)"
          [title]="'Pick your emoji…'"
          emoji='point-up'>
        </emoji-mart>
      </span>
      </div>
    </div>
  </div>
</div>
